import { RouteRecordRaw } from 'vue-router'

const personal: Array<RouteRecordRaw> = [
    {
        path: '/personal',
        name: 'personal',
        redirect: '/personal/personalInformation',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/personal/personalInformation',
                name: 'personalInformation',
                meta: {
                    title: '个人信息',
                    keepAlive: false
                },
                component: () => import('@/views/personal/personalInformation.vue')
            },
            {
                path: '/personal/changePassword',
                name: 'changePassword',
                meta: {
                    title: '修改密码',
                    keepAlive: false
                },
                component: () => import('@/views/personal/changePassword.vue')
            },
            {
                path: '/personal/updatePhone',
                name: 'updatePhone',
                meta: {
                    title: '更新手机号',
                    keepAlive: false
                },
                component: () => import('@/views/personal/updatePhone.vue')
            },
            {
                path: '/personal/updateMailbox',
                name: 'updateMailbox',
                meta: {
                    title: '更新邮箱号',
                    keepAlive: false
                },
                component: () => import('@/views/personal/updateMailbox.vue')
            }
        ]
    }
]

export default personal
